const API_BASE_URL = 'https://agrimocksbe.onrender.com/api';
const API_BASE_URL_LOCAL = 'http://localhost:5001/api';
const API_URL = API_BASE_URL;

export interface BlogCategory {
  _id: string;
  name: string;
  slug: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBlogCategoryData {
  name: string;
  description: string;
}

export interface UpdateBlogCategoryData {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

async function blogCategoryApiCall<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Something went wrong');
  }

  return data;
}

// Get all blog categories
export const getAllBlogCategories = async (): Promise<ApiResponse<BlogCategory[]>> => {
  try {
    const response = await blogCategoryApiCall<{ success: boolean; data: BlogCategory[] }>('/blog-categories');
    return {
      success: true,
      data: response.data
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to fetch blog categories'
    };
  }
};

// Create a new blog category
export const createBlogCategory = async (categoryData: CreateBlogCategoryData): Promise<ApiResponse<BlogCategory>> => {
  try {
    const response = await blogCategoryApiCall<{ success: boolean; data: BlogCategory }>('/blog-categories', {
      method: 'POST',
      body: JSON.stringify(categoryData)
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to create blog category'
    };
  }
};

// Update a blog category
export const updateBlogCategory = async (id: string, categoryData: UpdateBlogCategoryData): Promise<ApiResponse<BlogCategory>> => {
  try {
    const response = await blogCategoryApiCall<{ success: boolean; data: BlogCategory }>(`/blog-categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(categoryData)
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to update blog category'
    };
  }
};

// Delete a blog category
export const deleteBlogCategory = async (id: string): Promise<ApiResponse<void>> => {
  try {
    await blogCategoryApiCall<{ success: boolean }>(`/blog-categories/${id}`, {
      method: 'DELETE'
    });
    return {
      success: true
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to delete blog category'
    };
  }
}; 